import { brand, footerColumns, footerBlurb } from '@/content/shared';

export default function Footer() {
  return (
    <footer style={{ padding: '48px 16px 32px' }}>
      <div className="footer-row">
        <div style={{ flex: '0 1 320px' }}>
          <a href="/" style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: 700 }}>
            <img src={brand.logo} alt={brand.name} width={24} height={24} loading="lazy" decoding="async" style={{ borderRadius: '50%' }} />
            {brand.name}
          </a>
          <p style={{ marginTop: 12, fontSize: 14, color: 'var(--color-muted)' }}>{footerBlurb}</p>
        </div>
        {footerColumns.map((col) => (
          <div key={col.title} style={{ flex: '0 0 auto' }}>
            <h4 style={{ fontSize: 14, fontWeight: 700, marginBottom: 12 }}>{col.title}</h4>
            {col.links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                style={{ display: 'block', fontSize: 14, marginBottom: 6, color: 'var(--color-muted)' }}
              >
                {l.label}
              </a>
            ))}
          </div>
        ))}
      </div>

      <div
        style={{
          maxWidth: 1200,
          margin: '32px auto 0',
          display: 'flex',
          flexWrap: 'wrap',
          gap: 8,
          justifyContent: 'space-between',
          fontSize: 12,
          color: 'var(--color-muted)',
        }}
      >
        <span>© 2026 {brand.name}</span>
        <span>All rights reserved.</span>
      </div>
    </footer>
  );
}
